import styled, { keyframes } from 'styled-components';
const spin = keyframes(["0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}"]);
const getLoaderSize = ({
  loaderSize = 72
}) => loaderSize;
const getBorderSize = ({
  borderSize = 6
}) => borderSize;
const Index = styled.div.withConfig({
  displayName: "Loader__Index",
  componentId: "sc-1hskr88-0"
})(["position:relative;width:", "px;height:", "px;margin-top:", ";margin-right:auto;margin-bottom:", ";margin-left:auto;&:after,&:before{position:absolute;width:", "px;height:", "px;content:\"\";border:", "px solid transparent;border-top-color:", ";border-radius:100%;}&:before{z-index:1;animation:", " 1s infinite;}&:after{z-index:0;border:", "px solid #EBEBEB;}"], getLoaderSize, getLoaderSize, ({
  marginTop
}) => `${marginTop}px` || 'auto', ({
  marginBottom
}) => `${marginBottom}px` || 'auto', getLoaderSize, getLoaderSize, getBorderSize, ({
  theme: {
    color
  }
}) => color.primary, spin, getBorderSize);
export default Index;